<template>
  <v-card rounded>
    <v-card-title>
      <v-row no-gutters>
        <div>{{ $t('title-send-update-commodity') }}</div>
        <v-spacer />
        <div class="">
          <v-btn
            :disabled="isLoading"
            text
            class="mr-2"
            @click="onCloseDialog"
            >{{ $t('button-close') }}</v-btn
          >
          <v-btn
            :disabled="isLoading"
            :loading="isLoading"
            color="warning"
            @click="onUpdateCommodity"
            >{{ $t('button-send') }}</v-btn
          >
        </div>
      </v-row>
    </v-card-title>

    <v-card-text class="py-6">
      {{ $t('text-commodity-send-update') }}
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
  components: {},
  props: {},
  data: () => ({
    isLoading: false,
  }),
  computed: {},
  async created() {},
  watch: {},
  methods: {
    ...mapActions('vsl/quotation', [
      'resendMyQuotation',
      'fetchMyQuotation',
      'fetchMyQuotationActionLogList',
      'fetchMyQuotationCommodityList',
    ]),
    onCloseDialog() {
      this.$emit('close-dialog');
    },

    async onUpdateCommodity() {
      try {
        this.isLoading = true;
        await this.resendMyQuotation();
        await this.fetchMyQuotationActionLogList({ id: this.$route.params.id });
        await this.fetchMyQuotationCommodityList({ id: this.$route.params.id });
        await this.fetchMyQuotation({ id: this.$route.params.id });
        this.$emit('close-dialog');
        this.$message.success(this.$t('text-commodity-send-update-success'));
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style></style>
